﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingStadium } from "@tabler/icons-react";
import { GruposEmpresasCadenasDef } from "./GruposEmpresasCadenasDef";
export class GruposEmpresasCadenas extends Entity<GruposEmpresasCadenasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new GruposEmpresasCadenasDef(), parentKeys);
        //super.Form = import('./GruposEmpresasCat/GruposEmpresasCatForm').then((module) => module.GruposEmpresasCatForm);
        this.Title = "Cadenas de Tiendas";
        this.HelpText = '* Aquí puede ver la lista de todas las cadenas de tiendas disponibles. La columna "RELACIONADA" indica si la cadena está relacionada con este grupo de empresas. El botón AGREGAR creará una nueva Cadena y la relacionará con este grupo. El botón MODIFICAR permite cambiar el nombre de la cadena. Los botones RELACIONAR y QUITAR RELACIÓN permiten cambiar la relación de la cadena y grupo. Una cadena puede estar relacionada con un solo grupo de empresas.';
        this.Icon = IconBuildingStadium;
    }
}